import {EnumAware} from '../decorators/enum-aware.decorator';
import {EventEmitter, Injectable, Output} from '@angular/core';
import {ReviewsOverview} from '../model/reviews-overview';
import {SurveyQuery} from '../model/survey-query';
import {HttpClient, HttpHeaders} from '@angular/common/http';

const apiAuthHost = 'https://avid.api.avidratings.com/';
const apiHost = apiAuthHost + 'v1.0/';

@EnumAware
@Injectable()
export class SurveyApiService {

  publicReviewId: string;
  apiUsername = 'Z290b3VyYXBwcy1yZXZpZXdz';
  apiPassword = 'ZFFLcWRmS0MzWWtaeUwyMnZGcDd0NSM=';
  apiToken = null;
  reviewsOverview: ReviewsOverview = null;
  surveyQuery: SurveyQuery = new SurveyQuery();

  @Output() tokenLoaded = new EventEmitter<boolean>();
  @Output() reviewsOverviewLoaded = new EventEmitter<boolean>();
  @Output() surveyListLoaded = new EventEmitter<boolean>();

  constructor(private http: HttpClient) {}

  fetchSummaryAndReviews(publicReviewId: string) {
    // prevent auth requests and propagation without a publicReviewId
    if (publicReviewId === null) {
      return;
    }

    this.publicReviewId = publicReviewId;
    if (this.apiToken === null) {
      this.tokenLoaded.subscribe(
        (loaded: boolean) => {
          if (loaded && this.publicReviewId !== null) {
            // recursively call so we can fall through to the
            // survey data fetch below
            this.fetchSummaryAndReviews(this.publicReviewId)
          }
        }
      );
      this.fetchJWTToken();
    } else {
      this.fetchOverviewInfo();
      this.fetchSurveyList(null);
    }
  }

  fetchOverviewInfo() {
    this.http.get(apiHost + 'reviews/' + this.publicReviewId + '/overview', {
      headers: this.tokenHeaders()
    }).subscribe(
      data => {
          this.reviewsOverview = new ReviewsOverview(data['results']);
          this.reviewsOverviewLoaded.emit(true);
        },
        error => {
          console.log(error);
        }
      );
  }

  fetchSurveyList(queryURL: string) {
    if (!queryURL) {
      queryURL = apiHost + 'reviews/' + this.publicReviewId + '/surveys'
        + '?limit=' + this.surveyQuery.resultLimit
        + '&sortfield=' + this.surveyQuery.currentSortOption().field
        + '&sortdir=' + this.surveyQuery.currentSortOption().direction;
    }

    this.http.get(queryURL, {
      headers: this.tokenHeaders()
    }).subscribe(
        data => {
          this.surveyQuery.loadResults(data['results']);
          this.surveyListLoaded.emit(true);
        },
        error => {
          console.log(error);
        }
      );
  }

  fetchJWTToken() {
    this.http.post(apiAuthHost + 'auth', {
      'username': atob(this.apiUsername),
      'password': atob(this.apiPassword)
    }, {
      headers: this.authHeaders()
    }).subscribe(
        data => {
          this.apiToken = data['token'];
          this.tokenLoaded.emit(true);
        },
        error => {
          console.log(error);
        }
      );
  }

  tokenHeaders() {
    return new HttpHeaders({'Authorization' : 'bearer ' + this.apiToken});
  }

  authHeaders() {
    return new HttpHeaders({'Content-Type' : 'application/json'});
  }
}



// WEBPACK FOOTER //
// ./src/app/services/survey-api.service.ts